// ======================================================================
// File Name       : ContentDocumentAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import { commonCallApi } from '../../utils/ApiUtils';
import * as httpRequests from '../httpRequests/document';
import * as ActionTypes from '../../constants/actionTypes/content';
import { DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import { RETURN_MAX_NUM } from '../../constants/index';
import { hideLoading } from '../../utils/PageUtils';

export function searchDocumentList(searchInfo) {
  return dispatch => commonCallApi({
    path: 'document/GetList',
    data: searchInfo,
  }).then((result) => {
    if (searchInfo.selectTargetData) {
      const link = document.createElement('a');
      if (result && result.csvfileUrl) {
        link.href = result.csvfileUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      dispatch({
        type: ActionTypes.CONTENT_DOCUMENT_LIST,
        contentDocumentList: result,
      });
    }
  });
}

export function registerDocument(registerInfo) {
  return async (dispatch) => {
    const response = await httpRequests.registerDocumentDetail(registerInfo);
    dispatch(hideLoading());
    return dispatch(receiveRegisterResponse(response));
  };
}

function receiveRegisterResponse(resdata) {
  return {
    type: ActionTypes.CONTENT_DOCUMENT_REGISTER,
    resdata,
  };
}

export function getDocumentDetail(params) {
  return (dispatch) => {
    httpRequests.getDocumentDetail(params).then((resdata) => {
      dispatch(receiveDocumentDetail(resdata));
    });
  };
}

function receiveDocumentDetail(resdata) {
  let documentContentInfo = {};
  try {
    if (resdata
      && resdata.documentContentList
      && $.type(resdata.documentContentList) === 'array'
      && resdata.documentContentList.length > 0) {
      documentContentInfo = resdata.documentContentList[0];
    } else {
      documentContentInfo.noRecordFound = true;
    }
  } catch (error) {
    documentContentInfo.noRecordFound = true;
  }
  return {
    type: ActionTypes.CONTENT_DOCUMENT_DETAIL,
    documentContentInfo,
  };
}

export function editDocumentDetail(params) {
  return async (dispatch) => {
    const resdata = await httpRequests.editDocumentDetail(params);
    dispatch(hideLoading());
    return dispatch(receiveEditResponse(resdata));
  };
}

export function downloadDocument(params) {
  return (dispatch) => {
    commonCallApi({
      path: 'document/Download',
      data: params,
    })
      .then((camelizeJson) => {
        if (camelizeJson && camelizeJson.documentDownloadUrl) {
          const link = document.createElement('a');
          link.href = camelizeJson.documentDownloadUrl;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
  };
}

function receiveEditResponse(resdata) {
  return {
    type: ActionTypes.CONTENT_DOCUMENT_EDIT,
    resdata,
  };
}
